import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const CompanyPage = () => {
  return (
    <div className="min-h-screen pt-24 page-bg-shell page-bg-grid" data-testid="company-page">
      <Helmet>
        <title>Company | Wowrolla</title>
        <meta
          name="description"
          content="Learn about Wowrolla, an Ottawa, Canada based AI tool discovery and implementation advisory platform."
        />
      </Helmet>

      <section className="container mx-auto px-6 pb-14 max-w-4xl">
        <h1 className="text-4xl font-black mb-4" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
          Company
        </h1>
        <p className="text-sm mb-6" style={{ color: 'var(--text-muted)' }}>
          Ottawa, Ontario, Canada
        </p>

        <div className="terminal-grid p-6 mb-5">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
            What We Do
          </h2>
          <p style={{ color: 'var(--text-secondary)' }}>
            Wowrolla helps teams discover, evaluate, and implement AI tools with practical guidance. We combine transparent tool intelligence, comparison workflows, and optional consulting support so teams can make better buying decisions with less risk.
          </p>
        </div>

        <div className="terminal-grid p-6 mb-5">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
            Where We Operate
          </h2>
          <p style={{ color: 'var(--text-secondary)' }}>
            Wowrolla is based in Ottawa, Ontario, Canada and serves users in Canada, the United States, and other regions through our online platform.
          </p>
        </div>

        <div className="terminal-grid p-6">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
            Explore
          </h2>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" style={{ color: 'var(--accent-primary)' }} className="hover:underline">About Us</Link>
            <Link to="/contact" style={{ color: 'var(--accent-primary)' }} className="hover:underline">Contact</Link>
            <Link to="/privacy-policy" style={{ color: 'var(--accent-primary)' }} className="hover:underline">Privacy Policy</Link>
            <Link to="/terms-of-service" style={{ color: 'var(--accent-primary)' }} className="hover:underline">Terms of Service</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompanyPage;

